import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ae276c5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page d-full-w" }
const _hoisted_2 = { class: "info" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "物资信息", -1))
const _hoisted_4 = { class: "audit" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "审核信息", -1))
const _hoisted_6 = { class: "steps-wrapper d-flex" }
const _hoisted_7 = { class: "d-flex-1f d-center" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "已提交", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex-1f d-center d-relative line inactive" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "已接收", -1))
const _hoisted_11 = { class: "where" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "捐赠详情", -1))
const _hoisted_13 = { class: "bottom-wrapper d-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_RatioHeightContainer = _resolveComponent("RatioHeightContainer")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_van_cell_group, {
        class: "cell-group",
        border: false,
        clickable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_cell, {
            border: false,
            title: "捐赠人姓名",
            value: _ctx.suppliesInfo.donateName
          }, null, 8, ["value"]),
          _createVNode(_component_van_cell, {
            border: false,
            title: "捐赠时间",
            value: 
                        _ctx.suppliesInfo.createTimeStamp > 0
                            ? new Date(_ctx.suppliesInfo.createTimeStamp).format(
                                  'yyyy-MM-dd HH:mm:ss'
                              )
                            : ''
                    
          }, null, 8, ["value"]),
          _createVNode(_component_van_cell, {
            border: false,
            title: "物资名字",
            value: _ctx.suppliesInfo.suppliesName
          }, null, 8, ["value"]),
          _createVNode(_component_van_cell, {
            border: false,
            title: "物资数量",
            value: _ctx.suppliesInfo.qty
          }, null, 8, ["value"]),
          _createVNode(_component_van_cell, {
            border: false,
            title: "新旧程度",
            value: _ctx.suppliesInfo.oldAndNew
          }, null, 8, ["value"]),
          _createVNode(_component_van_cell, {
            border: false,
            title: "物资描述",
            value: _ctx.suppliesInfo.desc
          }, null, 8, ["value"]),
          _createVNode(_component_van_cell, {
            class: "flex-up-down",
            border: false,
            title: "物资照片"
          }, {
            value: _withCtx(() => [
              _createVNode(_component_van_row, {
                gutter: 10,
                class: "img-wrapper"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.suppliesImgs, (imgItem) => {
                    return (_openBlock(), _createBlock(_component_van_col, {
                      span: 6,
                      key: imgItem
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_RatioHeightContainer, { ratio: 80 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_van_image, {
                              width: "100%",
                              height: "100%",
                              fit: "cover",
                              radius: "6px",
                              src: _ctx.img(imgItem),
                              onClick: ($event: any) => (_ctx.previewSuppliesImgs(imgItem))
                            }, null, 8, ["src", "onClick"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode(_component_van_cell_group, {
        class: "cell-group",
        border: false,
        clickable: ""
      }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_van_cell, {
            border: false,
            title: "编号",
            value: _ctx.suppliesInfo.serialNumber
          }, null, 8, ["value"]), [
            [_vShow, _ctx.isShowSerialNumber()]
          ]),
          _createVNode(_component_van_cell, {
            border: false,
            title: "审核人",
            value: _ctx.suppliesInfo.aduitsName
          }, null, 8, ["value"]),
          _createVNode(_component_van_cell, {
            border: false,
            title: "审核时间",
            value: 
                        _ctx.suppliesInfo.aduitsTime > 0
                            ? new Date(_ctx.suppliesInfo.aduitsTime).format(
                                  'yyyy-MM-dd HH:mm:ss'
                              )
                            : ''
                    
          }, null, 8, ["value"]),
          _withDirectives(_createVNode(_component_van_cell, {
            border: false,
            title: "拒绝信息",
            value: _ctx.suppliesInfo.refuseMsg
          }, null, 8, ["value"]), [
            [_vShow, _ctx.isShowRefuseMsg()]
          ]),
          _createVNode(_component_van_cell, {
            class: "flex-up-down",
            border: false,
            title: "审核流程"
          }, {
            value: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_van_icon, { name: "checked" })
                  ]),
                  _hoisted_8
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(
                                    _ctx.suppliesInfo.supplierStatus == 3
                                        ? 'd-flex-1f d-center d-relative line'
                                        : 'd-flex-1f d-center d-relative line inactive'
                                )
                }, null, 2),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.aduitsCheck)
                }, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_van_icon, { name: "checked" })
                  ]),
                  _createElementVNode("div", null, _toDisplayString(_ctx.suppliesInfo.supplierStatus == 3
                                            ? "已拒绝"
                                            : _ctx.suppliesInfo.supplierStatus == 1
                                            ? "待审核"
                                            : "已审核"), 1)
                ], 2),
                _hoisted_9,
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.completeCheck)
                }, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_van_icon, { name: "checked" })
                  ]),
                  _hoisted_10
                ], 2)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_11, [
      _hoisted_12,
      _createVNode(_component_van_cell_group, {
        class: "cell-group",
        border: false,
        clickable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_cell, {
            border: false,
            title: "捐赠处",
            value: _ctx.suppliesInfo.donateTo
          }, null, 8, ["value"]),
          _createVNode(_component_van_cell, {
            border: false,
            title: "捐赠描述",
            value: _ctx.suppliesInfo.donateDesc
          }, null, 8, ["value"]),
          _createVNode(_component_van_cell, {
            border: false,
            title: "新闻链接",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.copy(_ctx.suppliesInfo.donateToUrl))),
            value: "点击复制链接"
          }),
          _createVNode(_component_van_cell, {
            class: "flex-up-down",
            border: false,
            title: "捐赠照片"
          }, {
            value: _withCtx(() => [
              _createVNode(_component_van_row, {
                gutter: 10,
                class: "img-wrapper"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.imgs, (imgItem) => {
                    return (_openBlock(), _createBlock(_component_van_col, {
                      span: 6,
                      key: imgItem
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_RatioHeightContainer, { ratio: 80 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_van_image, {
                              width: "100%",
                              height: "100%",
                              fit: "cover",
                              radius: "6px",
                              src: _ctx.img(imgItem),
                              onClick: ($event: any) => (_ctx.previewImage(imgItem))
                            }, null, 8, ["src", "onClick"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ], 512), [
      [_vShow, _ctx.isShowDonation()]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_13, [
      _createVNode(_component_van_button, {
        type: "primary",
        class: "btn disable margin-right",
        block: "",
        onClick: _ctx.Delete
      }, {
        default: _withCtx(() => [
          _createTextVNode("删除")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_van_button, {
        type: "primary",
        class: "btn margin-left",
        block: "",
        onClick: _ctx.Update
      }, {
        default: _withCtx(() => [
          _createTextVNode("编辑")
        ]),
        _: 1
      }, 8, ["onClick"])
    ], 512), [
      [_vShow, _ctx.isShowEdit()]
    ])
  ]))
}